<!--
    描述：新增、编辑用户组弹框等
    时间：2020-04-27
    Created by yefan
-->
<template>
    <div class="h100">
        <el-form :model="userGroupForm"
                 :rules="userGroupRules"
                 ref="userGroupForm"
                 label-width="90px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="组名称" prop="sname" :show-message="false">
                        <el-input v-model="userGroupForm.sname" :disabled="isDisabled" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--
            <el-row>
                <el-col :span="24">
                    <el-form-item label="组类型" prop="groupType" :show-message="false">
                        <el-select v-model="userGroupForm.groupType" :disabled="isDisabled" placeholder="请选择">
                            <el-option v-for="(item, index) in groupTypes"
                                       :key="'类型' + index"
                                       :label="item.sname"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="角色" prop="roleIds" :show-message="false">
                        <tree-select v-model="userGroupForm.roleIds"
                                     :multiple="true"
                                     :options="roleTreeData"
                                     :disabled="isDisabled"
                                     :append-to-body="true"
                                     :default-expand-level="1"
                                     placeholder="请选择">
                        </tree-select>
                    </el-form-item>
                </el-col>
            </el-row>
            -->
        </el-form>
    </div>
</template>
<script>
    import {selectRoleTree} from 'api/system/role.js'
    import {insertSysGroup, getSysGroupInfo, getDictsByValue} from 'api/system/group.js'

    export default {
        props: {
            mode: {
                type: String,
                default: () => {
                    return ''
                }
            },
            userGroupId: {
                type: String,
                default: () => {
                    return ''
                }
            }
        },

        data() {
            return {
                roleTreeData: [],
                userGroupForm: {
                    sname: '',
                    //roleName: null,
                    //groupType: '',
                    //parentId: '',
                    //roleIds: []
                },
                groupTypes: [],
                userGroupRules: {
                    sname: [{required: true}],
                    roleIds: [{required: true, type: 'array', trigger: 'change'}],
                    groupType: [{required: true}]
                }
            }
        },

        methods: {
            // 查看、编辑初始渲染数据
            initUserGroup() {
                let param = {};
                param.id = this.userGroupId;
                getSysGroupInfo(param).then(res => {
                    this.userGroupForm = res.data;
                });
            },

            //确定按钮事件
            doSave() {
                this.$refs.userGroupForm.validate((valid) => {
                    if (valid) {
                        insertSysGroup(this.userGroupForm).then(res => {
                            res.code == 0 ? this.$message.success("保存成功！") : this.$message.error(res.msg);
                            //点击确定后关闭弹框
                            this.$emit('dialogClose')
                        });
                    } else {
                        this.$message.warning("请完善必填项!");
                    }
                });
            },

            //获取组类型
            getGroupTypes() {
                let param = {};
                param.value = "1003";   //1001
                getDictsByValue(param).then(res => {
                    this.groupTypes = res.data
                })
            },

            // 获取角色数据
            getRoleData() {
                let param = {};
                selectRoleTree(param).then(res => {
                    this.roleTreeData = res.data
                })
            }
        },

        created() {
            if (this.mode !== 'add') this.initUserGroup();
            this.getRoleData();
            this.getGroupTypes();
        },

        computed: {
            // 是否可编辑
            isDisabled() {
                return this.mode === 'view' ? true : false
            }
        }
    }
</script>

<style lang="less"></style>
